<script setup lang="ts">
import {PropType, ref} from "vue";
import LoginForm from "@/components/LoginForm/LoginForm.vue";
import RegisterForm from "@/components/RegisterForm/RegisterForm.vue";
import ForgotPasswordForm from "@/components/ForgotPasswordForm/ForgotPasswordForm.vue";
import {useUserStore} from "@/stores/userStore";
import {useI18n} from 'vue-i18n';
import {useRoute, useRouter} from "vue-router";

const route = useRoute();
const router = useRouter();

const userStore = useUserStore();

const loginView = ref<"login" | "register" | "forgot-pass">("login");

const {t} = useI18n();

const props = defineProps({
  prevRoute: {
    type: Object,
  }
});

// Import test user image
const papaImage = new URL('@/assets/papaimage.jpg', import.meta.url).href;

// Added a test user
function login() {
  userStore.login({
    id: 1,
    name: 'Ioanna Pappa',
    email: 'test@test.com',
    phone: '698123456',
    address: 'Test',
    birthDate: '1',
    isActive: true,
    userImage: papaImage,
  });

}

function addTripFromLogin() {
  if (props.prevRoute.path == "/recommendations" || props.prevRoute.path == "/search") {
    router.push({
      path: props.prevRoute.path,  // current route path
      query: {...props.prevRoute.query, ...route.query},  // modify/add new query params
    });
  } else {
    router.go(-1);
  }

}
</script>

<template>
<!--  <div v-if="props.prevRoute">{{props.prevRoute}}</div>-->

  <div class="login-col flex w-full min-h-[78vh] overflow-y-hidden">
    <div class="login-left-col bg-primary-account flex items-center justify-center w-2/4 relative">
      <div class="self-start top-9 left-14 flex flex-row items-center font-semibold cursor-pointer absolute"
           @click="$router.back()">
        <img src="@/assets/icons/svg/Left_24x24.svg" alt="back" class="mr-2">
        {{ t('auth.back') }}
      </div>
      <img src="@/assets/images/locker.svg" alt="locker" class="w-[340px]"/>
    </div>
    <div class="login-right-col flex flex-col w-2/4 justify-center items-center ">
      <transition mode="out-in" name="fade">
        <LoginForm v-if="loginView == 'login'" @show-register="loginView = 'register'"
                   @forgot-password="loginView = 'forgot-pass'"
                   @login-to-site="login(); addTripFromLogin()"
        />
        <RegisterForm v-else-if="loginView == 'register'" @show-login="loginView = 'login'"/>
        <ForgotPasswordForm v-else-if="loginView == 'forgot-pass'"/>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.1s ease-out;
}

.fade-leave-active {
  transition: opacity 0.1s ease-in;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

@media (max-width: 768px) {
  .login-col {
    margin-top: 2rem;
    min-height: unset;
  }

  .login-left-col {
    display: none;
  }

  .login-right-col {
    width: 100%;
    height: 100%;
  }

}

</style>
